import { RootReducerType } from "../CombineReducer";

export const useGetOrgList = (state: RootReducerType) => state.organisation.orgList;
export const useGetOrgListLoading = (state: RootReducerType) => state.organisation.isLoading;
export const useGetSelectedOrgDetail = (state: RootReducerType) => state.organisation.orgDetail;
export const useGetOrgUserList = (state: RootReducerType) => state.organisation.orgDetail?.userList;
export const useGetOrgSiteList = (state: RootReducerType) => state.organisation.orgDetail?.siteList;
